<div class="modal-body">
  <div class="prompt" [innerHtml]="tncBody"></div>

  <div class="w-100 mt-4">
    <form [formGroup]="formGroup" class="d-flex align-items-center justify-content-center flex-column">
      <div *ngIf="showJobTitleField" class="d-flex align-items-center flex-column mb-3 w-100">
        <label for="jobTitle" class="mb-1">{{ 'Submit_job_title' | translate }}</label>
        <input
          type="text"
          id="jobTitle"
          class="form-control mt-3 job-title-input"
          formControlName="jobTitle"
          placeholder="Job title"
        />
      </div>
      <div class="d-flex align-items-center">
        <input type="checkbox" id="tnCs" formControlName="tnCs" />
        <label for="tnCs" [innerHTML]="tncAccept"></label>
      </div>
    </form>
  </div>
  <button class="btn btn-primary mt-3" type="button" (click)="onSubmit()" [disabled]="formGroup.invalid">
    {{ 'Submit' | translate }} <fa-icon class="ms-1" [icon]="['far', 'chevron-right']" size="sm"></fa-icon>
  </button>
</div>
